var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreendot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.32617,
    y: 1.02344,
    width: 11.0656,
    height: 11.0656,
    stroke: "#02A750",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.08984,
    y: 2.78711,
    width: 7.53938,
    height: 7.53938,
    rx: 3.76969,
    fill: "#02A750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreendot);
export default __webpack_public_path__ + "static/media/greendot.331c52170b2f40c1b4510f5bbe148978.svg";
export { ForwardRef as ReactComponent };